import { useState, useEffect } from "react";
import { AdminLayout } from "./AdminLayout";
import { LoginPage } from "./LoginPage";
import { NarrativesView } from "./NarrativesView";
import { UsersView } from "./UsersView";
import { AnalyticsView } from "./AnalyticsView";
import { SettingsView } from "./SettingsView";
import { NewNarrativeModal } from "./NewNarrativeModal";
import { AdminThemeProvider } from "../../contexts/AdminThemeContext";
import { useAdminTheme } from "../../contexts/useAdminTheme";

const AdminPageInner = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentView, setCurrentView] = useState("narratives");
  const [showNewNarrativeModal, setShowNewNarrativeModal] = useState(false);
  const [isDrilledDown, setIsDrilledDown] = useState(false);
  const { effectiveTheme } = useAdminTheme();

  // Check for existing auth in localStorage (mock)
  useEffect(() => {
    const authStatus = localStorage.getItem("forward_admin_auth");
    if (authStatus === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    localStorage.setItem("forward_admin_auth", "true");
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("forward_admin_auth");
    setIsAuthenticated(false);
  };

  const handleExportManifest = () => {
    // Mock export functionality
    console.log("Exporting narratives manifest...");
    alert(
      "Export functionality is a placeholder. In production, this would download a JSON/CSV file.",
    );
  };

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return (
      <div data-admin-theme={effectiveTheme}>
        <LoginPage onLogin={handleLogin} />
      </div>
    );
  }

  // Render the appropriate view based on currentView state
  const renderView = () => {
    switch (currentView) {
      case "narratives":
        return (
          <NarrativesView
            onDrillDownChange={setIsDrilledDown}
            onExportManifestClick={handleExportManifest}
            onViewEngagement={() => setCurrentView("analytics")}
          />
        );
      case "users":
        return <UsersView />;
      case "analytics":
        return <AnalyticsView />;
      case "settings":
        return <SettingsView />;
      default:
        return (
          <NarrativesView
            onDrillDownChange={setIsDrilledDown}
            onExportManifestClick={handleExportManifest}
            onViewEngagement={() => setCurrentView("analytics")}
          />
        );
    }
  };

  return (
    <div data-admin-theme={effectiveTheme}>
      <AdminLayout
        currentView={currentView}
        onViewChange={setCurrentView}
        onNewNarrativeClick={() => setShowNewNarrativeModal(true)}
        onAddUserClick={() => {
          /* Placeholder - no action yet */
        }}
        onLogout={handleLogout}
        isDrilledDown={isDrilledDown}
      >
        {renderView()}
      </AdminLayout>
      {showNewNarrativeModal && (
        <NewNarrativeModal onClose={() => setShowNewNarrativeModal(false)} />
      )}
    </div>
  );
};

export const AdminPage = () => (
  <AdminThemeProvider>
    <AdminPageInner />
  </AdminThemeProvider>
);
